module.exports = __webpack_public_path__ + "img/topjxwl_bg.915b4fac.png";